import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuardService } from '../../shared/filters/auth-guard.service';
import { MonitoramentoComponent } from './monitoramento.component';
import { AgendaFinanceiraComponent } from './agenda-financeira/agenda-financeira.component';
import { LogAgendaFinanceiraComponent } from './agenda-financeira/log-agenda-financeira/log-agenda-financeira.component';

const routes: Routes = [{
  path: '',
  component: MonitoramentoComponent,
  children: [
    {
      path: 'agenda-financeira',
      component: AgendaFinanceiraComponent,
      canActivate: [AuthGuardService],
      data: {roles: ['AGENDA_FINANCEIRA']},
    },   
    {
      path: 'log-agenda-financeira',
      component: LogAgendaFinanceiraComponent,
      canActivate: [AuthGuardService],
      data: {roles: ['AGENDA_FINANCEIRA']},
    },       
  ],

}];

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forChild(routes)
  ],
  exports: [
    RouterModule
  ],
})
export class MonitoramentoRoutingModule { }

export const routedComponents = [
  MonitoramentoComponent,  
  AgendaFinanceiraComponent,
  LogAgendaFinanceiraComponent,
 
];
